import { useTranslation } from 'react-i18next'

import type { AppError } from '@/shared/api'

/**
 * Messages are resolved by code, not by server text: codes are stable and
 * translatable, server text is neither.
 *
 * Order: local translation for `code` → server `message` → generic fallback.
 */
export function useErrorMessage() {
  const { t } = useTranslation('common')

  return (error: AppError | null | undefined): string => {
    if (!error) return ''

    if (error.code !== undefined) {
      const key = `errors.${error.code}`
      const translated = t(key, { defaultValue: '' })
      if (translated !== '') return translated
    }

    if (error.message !== '') return error.message

    return t('errors.UNKNOWN', { defaultValue: 'Something went wrong' })
  }
}
